import TopBar from '../../shared/ui/TopBar';
import Tab from '../../components/myPage/Tab';

const MyPage = () => {
  return (
    <>
      <TopBar pageName="my-page">마이 페이지</TopBar>
      <Tab />
    </>
  );
};

export default MyPage;
